export const COMMENT_PREFIXES = {
  ASSIGNEE_CHANGE: 'Assignee Change Reason:',
  DUE_DATE_CHANGE: 'Due Date Change Reason:',
  CANCELLATION: 'Cancellation Reason:',
} as const;

export const isAssigneeChangeComment = (comment: string): boolean =>
  comment.startsWith(COMMENT_PREFIXES.ASSIGNEE_CHANGE);

export const filterTaskPerformanceComments = (comment: string): string =>
  isAssigneeChangeComment(comment) ? '' : comment;

export const createAssigneeChangeComment = (reason: string): string =>
  `${COMMENT_PREFIXES.ASSIGNEE_CHANGE} ${reason}`;

export const createDueDateChangeComment = (reason: string): string =>
  `${COMMENT_PREFIXES.DUE_DATE_CHANGE} ${reason}`;

/**
 * Format the cancellation reason as an activity-history comment. Uses
 * the same "Prefix: reason" shape as the assignee/due-date change
 * helpers so the ChangeLog on desktop parses cancel entries with the
 * same code path.
 */
export const createCancelComment = (reason: string): string =>
  `${COMMENT_PREFIXES.CANCELLATION} ${reason}`;
